<template>
  <b-form novalidate @submit.prevent="submit" class="ml-auto mr-auto">
<!--    <p v-if="showError">{{ $t('password_reset.error') }}</p>-->
<!--    <p v-if="showSuccess">{{ $t('password_reset.success') }}</p>-->
    <b-alert v-if="showError" show variant="warning" class="text-center">{{ $t('password_reset.send_email_error') }}</b-alert>
    <b-form-group label-for="mail">
      <b-form-input :placeholder="$t('password_reset.mail.label')" id="mail" v-model="mail" type="email" required :state="$v.mail.$dirty ? !$v.mail.$error : null" @blur="$v.mail.$touch"></b-form-input>
    </b-form-group>
    <b-row>
      <div class="col-12 col-sm-6 mb-2 mb-sm-0">
        <b-link to="/login" class="btn btn-block btn-secondary">{{ $t('register.cancel') }}</b-link>
      </div>
      <div class="col-12 col-sm-6">
<!--        <b-button class="btn-block" type="submit" variant="primary">{{ $t('password_reset.submit') }}</b-button>-->
        <b-button class="btn-block" type="submit" variant="primary">{{ $t('password_reset.send_link') }}</b-button>
      </div>
    </b-row>
  </b-form>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'PasswordResetForm',
  data () {
    return {
      mail: null,
      showError: false,
      showSuccess: false
    }
  },
  methods: {
    async submit () {
      this.$v.$touch()
      if (!this.$v.$error) {
        let result
        try {
          result = await this.$api.user.passwordReset({ mail: this.mail })
          console.log(result)
          if (result) {
            this.$router.replace('/password-reset-send-mail')
          }
        } catch (e) { // network error etc.
          result = false
        }

        this.showError = !result
        this.showSuccess = !!result
      }
      return false
    }
  },
  validations: {
    mail: {
      required,
      email
    }
  }
}
</script>

<style lang="scss" scoped>
  form {
    max-width: 500px;
    font-family: "Roboto Condensed", sans-serif;
  }
</style>
